import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  PHONE_1,
  PHONE_2,
  ACCOUNT_NUMBER,
  BANK_NAME,
  CURRENCY,
  LEASE_DUE_DATE,
  MONTHLY_DUE_DATE,
  ROUTING_NUMBER,
  YEARLY_DUE_DATE,
} from "./consts";
import { useGetCommunityFinancialInfo } from "@/services";
import { useEffect, useState } from "react";
import { getRequiredFields } from "@/lib/utils";
import { schema } from "./validations";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useStep3 = () => {
  const form = useForm<any>({
    defaultValues: {
      [YEARLY_DUE_DATE]: undefined,
      [MONTHLY_DUE_DATE]: undefined,
      [LEASE_DUE_DATE]: undefined,
      [CURRENCY]: "USD",
      [BANK_NAME]: undefined,
      [ROUTING_NUMBER]: undefined,
      [ACCOUNT_NUMBER]: undefined,
      [PHONE_1]: undefined,
      [PHONE_2]: undefined,
    },
    resolver: zodResolver(schema),
  });
  const [monthlyDateKey, setMonthlyDateKey] = useState<number>(
    Math.random() * 2
  );

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const {
    data: communityFinancialInfo,
    isLoading: isFinancialInfoLoading,
    isRefetching: isFinancialInfoRefetching,
  } = useGetCommunityFinancialInfo({
    community_id: communityData?.communityId || "",
    queryParams: {
      enabled: !!communityData?.communityId,
    },
  });

  useEffect(() => {
    if (communityFinancialInfo) {
      form.reset({
        [YEARLY_DUE_DATE]:
          communityFinancialInfo?.data?.[YEARLY_DUE_DATE] || undefined,
        [MONTHLY_DUE_DATE]:
          communityFinancialInfo?.data?.[MONTHLY_DUE_DATE]?.toString() ||
          undefined,
        [LEASE_DUE_DATE]:
          communityFinancialInfo?.data?.[LEASE_DUE_DATE] || undefined,
        [CURRENCY]: communityFinancialInfo?.data?.[CURRENCY] || undefined,
        [BANK_NAME]: communityFinancialInfo?.data?.[BANK_NAME] || undefined,
        [ROUTING_NUMBER]:
          communityFinancialInfo?.data?.[ROUTING_NUMBER] || undefined,
        [ACCOUNT_NUMBER]:
          communityFinancialInfo?.data?.[ACCOUNT_NUMBER] || undefined,
        [PHONE_1]: communityFinancialInfo?.data?.[PHONE_1] || undefined,
        [PHONE_2]: communityFinancialInfo?.data?.[PHONE_2] || undefined,
      });
      setMonthlyDateKey(Math.random() * 2);
    }
  }, [communityFinancialInfo]);

  return {
    form,
    requiredFields,
    isFinancialInfoLoading,
    isFinancialInfoRefetching,
    monthlyDateKey,
  };
};

export default useStep3;
